<template>
    <div>
        <div class="w_1200 clearfix2 box_mh20">
            <div class="fl black6_text box_pt8">今天是 <span v-text="now">2020年8月11日 星期二</span></div>
            <div class="fr">
                <Search/>
            </div>
        </div>
        <!--end一行-->

        <div class="clearfix2 box_mt20 w_1200">
            <div class="h_th">
                <h4 class="th_l fl font_18 font_b blue_text box_pw12">全文搜索</h4>
            </div>
            <!--end标题-->

            <table class="list_table blue_link box_c hover_table_bj box_mt20">
                <thead>
                <tr class="black9_text">
                    <th></th>
                    <th>资源编号</th>
                    <th>公告编号</th>
                    <th>项目名称</th>
                    <th>总面积</th>
                    <th width="110px;">资源类型</th>
                    <th width="50px;">状态</th>
                    <th width="50px;">操作</th>
                </tr>
                </thead>
                <tbody v-if="dataList !== undefined && dataList !== null && dataList.length>0">
                <tr v-for="(data,index) in dataList" :key="index">
                    <td><span class="num_box blue_bj" v-text="index+1"></span></td>
                    <td v-text="data.zybh"></td>
                    <td><span class="td_a hide2" v-text="data.ggh"></span></td>
                    <td><span class="td_a hide2" v-text="data.xmmc"></span></td>
                    <td><span v-text="data.syqmj"></span>m<sup>2</sup></td>
                    <td v-text="data.zylxText"></td>
                    <td v-text="data.zyztText"></td>
                    <td><a :href="detailUrl.qwss(data.id)">查看</a></td>
                </tr>
                </tbody>
                <tbody v-else>
                <tr>
                    <td colspan="8" style="color: #999;display: none">暂无记录</td>
                </tr>
                </tbody>
            </table>

            <Pagination :pagination="pagination" :params="params" :start="start" :end="end" :maxEnd="maxEnd" @changeStartAndEnd="changeStartAndEnd"/>
        </div>
        <!--end一行-->
    </div>
</template>

<script>
    import {api} from "@/core/api"
    import {getNow, getQueryVariable} from '@/core/common'
    import {detailUrl} from '@/core/getDetailUrl'
    import Search from "@/components/Search";
    import Pagination from "@/components/Pagination";

    export default {
        name: "Home",
        components: {Pagination, Search},
        data() {
            return {
                detailUrl: detailUrl,
                now: null,
                dataList: [],
                pagination: {
                    currentPage: 1,
                    rows: 20,
                    total: 100,
                    totalPage: 5
                },
                params: {
                    page: 1,
                    rows: 5,
                    xmmc: null
                },
                start: 1,
                end: 5,
                maxEnd: 5
            }
        },
        mounted() {
            this.now = getNow();
            let keyword = getQueryVariable("keyword");
            if (keyword) {
                this.params.xmmc = decodeURI(keyword);
            }
            this.getAllData();
        },
        methods: {
            changeStartAndEnd(start, end) {
                this.start = start;
                this.end = end;
            },
            getAllData() {
                api.getQwssList(this.params).then(response => {
                    this.dataList = response.data;
                });
                api.getQwssPagination(this.params).then(response => {
                    this.pagination = response.data;
                    this.start = 1;
                    this.end = this.pagination.totalPage < this.maxEnd ? this.pagination.totalPage : this.maxEnd;
                })
            }
        },
        watch: {
            "params.page": {
                handler() {
                    api.getQwssList(this.params).then(response => {
                        this.dataList = response.data;
                    });
                }
            }
        }
    }
</script>

<style scoped>

</style>
